import React from "react";
import fallback from "assets/images/fallbackAvatar.png";
import { getFormatedPhoneNumber } from "../helpers";

import {
  StyledCard,
  StyledImage,
  StyledTitleMemberName,
  StyledParagraphMemberRole,
  StyledParagraphMemberContact,
} from "./style";

export interface Props {
  BlMemberImage: string;
  BlMemberName: string;
  BlMemberRole: string;
  BlMemberTelephone: string;
  BlMemberEmail: string;
}

const MemberInfo: React.FC<Props> = ({
  BlMemberImage,
  BlMemberName,
  BlMemberRole,
  BlMemberTelephone,
  BlMemberEmail,
}) => {
  return (
    <StyledCard bodyStyle={{ padding: 0 }}>
      <StyledImage
        alt="BL member"
        src={BlMemberImage || fallback}
        onError={e => {
          e.currentTarget.src = fallback; // TODO remove this on error parameter?
        }}
      />
      <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-between", height: "100%" }}>
        <div>
          <StyledTitleMemberName level={5} style={{ marginBottom: "0.2em" }}>
            {BlMemberName}
          </StyledTitleMemberName>
          {BlMemberRole?.length ? (
            <StyledParagraphMemberRole style={{ marginBottom: "0.2em" }}>
              <p>{BlMemberRole}</p>
            </StyledParagraphMemberRole>
          ) : (
            <StyledParagraphMemberRole>
              <p>Medlem</p>
            </StyledParagraphMemberRole>
          )}
        </div>
        <StyledParagraphMemberContact ellipsis>
          <a href={`tel:${BlMemberTelephone}`}>{getFormatedPhoneNumber(BlMemberTelephone)}</a>
          <br />
          <a href={`mailto:${BlMemberEmail}`}>{BlMemberEmail}</a>
        </StyledParagraphMemberContact>
      </div>
    </StyledCard>
  );
};

export default MemberInfo;
